/*
<summary>
   This functional component renders the Equipment Management landing page - menu buttons
   that route to the Tool Management module, the Equipment Inspection Menu module, and BOM
   Search.
   Developer: Aashish Singh, Created Date: 01-Sep-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Header from '../../shared-components/header/header';
import RoutesConstants from '../../shared-components/routes/routes-constants';
import './equipment-management.css';

/**
* Renders the Equipment Management menu - a hub page with buttons routing to Tool
* Management, Equipment Inspection Menu, and BOM Search.
*/
const EquipmentManagement = () => {
  const history = useHistory();

  const menuItems = [
    { labelKey: 'tool_management_menu', route: RoutesConstants.ToolManagement },
    { labelKey: 'equipment_inspection_menu', route: RoutesConstants.EquipmentInspectionMenu },
    { labelKey: 'tool_bom', route: RoutesConstants.ToolBOM },
  ];

  return (
    <div className="em-page">
      <div className="icon-nav navbar-fixed-top device-nav-bar userTopNav">
        <div className="row align-items-center">
          <Header
            className="col"
            label="equipment_management"
          />
        </div>
      </div>

      <div className="card card-page card-body">
        <div className="operator-box operator-name pt-3">
          <div className="row m-0">
            {menuItems.map((item) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 col-xxl-2 mb-2">
                <button
                  key={item.labelKey}
                  type="button"
                  className="em-menu-card"
                  onClick={() => history.push(item.route)}
                >
                  <FormattedMessage id={item.labelKey} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default observer(EquipmentManagement);
